/**
 * A symbol for accessing the name of a {@link FunctionReference} at runtime.
 */
export const functionName = Symbol.for("functionName");
